export default __webpack_public_path__ + "static/media/GAME-Credits-G-180.0c842e7d.png";